import 'react-circular-progressbar/dist/styles.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import _app from '../../../server';
import defPic from 'assets/img/icons/default_pic.jpg';

import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgressbar } from 'react-circular-progressbar';
import BootstrapTable from 'react-bootstrap-table-next';

const moment = require('moment');

const HistoryTable = ({
    xs,
    md,
    lg,
    openTourDetail,
    history,
    isFilterOn,
    filter,
    dispatch,
    auth,
    actionGetHistory,
    actionGetFilteredHistory,
    actionSetDefaultPic,
    actionNextPage
}) => {
    const { byid, list, currentPage, pageCount, itemPerPage } = history;
    let data = [];
    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage;

    if (indexEnd > list.length) {
        indexEnd = list.length;
    }

    let itemsList = list.slice(indexStart, indexEnd);
    let isItemNull = itemsList.find(e => {
        return e === -1;
    });

    if (!isItemNull) {

        data = [];
        let bil = indexStart + 1;

        itemsList.forEach(index => {
            const _history = byid[index];

            if (_history.name.length < 1) {
                return;
            }

            let i = Math.random();
            let names = _history.name.map(n => {
                return (
                    <p key={n + i} className='table-text-cont' >
                        {n}
                    </p >
                )
            });
            let staffIds = _history.staffId.map(n => {
                return (
                    <p key={n} className='table-text-cont' >
                        {n}
                    </p >
                )
            });
            let c = 0;
            let phones = _history.phoneNumber.map(n => {
                c = c+1;
                return (
                    <p key={n+c} className='table-text-cont' >
                        {n}
                    </p >
                )
            });


            const item = {
                itKey: _history.trackerId,
                trackerId: _history.trackerId,
                bil: `${bil}`,
                link: [],
                name: <div>{names}</div>,
                staffId: <div>{staffIds}</div>,
                callerId: _history.callerId,
                phoneNumber: <div>{phones}</div>,
                zone: _history.zone,
                progress: _history.progress,
                timestamp: moment(_history.timestamp).format('YYYY/MM/DD hh:mm:ss A')
            };

            for (let i = 0; i < _history.link.length; i++) {
                let img_link = defPic;
                if (!_history.useDefault[i]) {
                    if (_history.container[i] !== null && _history.filename[i] !== null) {
                        img_link = `${_app.api}Storages/${_history.container[i]}/download/${_history.filename[i]}?access_token=${auth}`;
                    } else if (_history.link[i] !== null) {
                        img_link = _history.link[i];
                    }
                }
                item.link = [...item.link, img_link];
            }

            data.push(item);
            bil++;
        });

    }
    else {
        if (isFilterOn) {
            //console.log("Fetch actionGetFilteredHistory > filter:\n", filter);
            dispatch(actionGetFilteredHistory(indexStart, itemPerPage, filter));
            return <p className='text-center'>Loading ....</p>;
        } else {
            //console.log("Fetch actionGetHistory > filter:\n", filter);
            dispatch(actionGetHistory(indexStart, itemPerPage));
            return <p className='text-center'>Loading ....</p>;
        }
    }

    if (data.length < 1) {
        //console.log(`HistoryTable > currentPage : ${currentPage} pageCount: ${pageCount}`);
        if (currentPage < pageCount) {

            actionNextPage(currentPage + 1);
            return <p className='text-center'>Loading ....</p>;
        }
    }

    let imgFormatter = (links, row) => {

        let idx = 0;
        let avatars = links.map(link => {
            idx += 1;
            return (
                <div className='table-img-cont' key={link + idx} style={{ padding: "5px" }}>
                    <img
                        onError={() => {
                            dispatch(actionSetDefaultPic(row.trackerId), idx - 1);
                        }}
                        src={link}
                        height='100%'
                        alt=''
                    />
                </div>
            )
        })
        return (
            <div key={Math.random()}>
                {avatars}
            </div>
        );
    };

    let progressFormatter = cell => {
        let nume = cell.split('/')[0];
        let denum = cell.split('/')[1];
        let percent = (nume / denum) * 100;
        return (
            <div className='table-img-cont'>
                <CircularProgressbar
                    value={percent}
                    text={cell}
                    styles={{
                        text: {
                            fill: '#ea5a5a'
                        },
                        path: {
                            stroke: '#ea5a5a'
                        }
                    }}
                    strokeWidth='12'
                />
            </div>
        );
    };

    let columns = [
        {
            dataField: 'trackerId',
            text: 'Tracker ID',
            hidden: true,
            sort: true
        },
        {
            dataField: 'bil',
            text: '#',
            headerClasses: 'table-col-head',
            sort: true,
            headerStyle: { whiteSpace: 'nowrap', width: '40px' }
        },
        {
            dataField: 'link',
            text: ' ',
            headerClasses: 'table-col-head',
            headerStyle: { width: '90px' },
            formatter: imgFormatter,
            sort: false
        },
        {
            dataField: 'name',
            text: 'Name',
            headerClasses: 'table-col-head text-left',
            classes: 'text-left',
            sort: true
        },
        {
            dataField: 'staffId',
            text: 'Staff No',
            hidden: lg,
            headerClasses: 'table-col-head',
            headerStyle: { width: '100px' },
            sort: true
        },
        {
            dataField: 'callerId',
            text: 'Device',
            hidden: md,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'phoneNumber',
            text: 'Phone Number',
            hidden: lg,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'zone',
            text: 'Zone',
            headerClasses: 'table-col-head',
            hidden: xs,
            sort: true
        },
        {
            dataField: 'progress',
            text: 'Progress',
            hidden: md,
            headerClasses: 'table-col-head',
            formatter: progressFormatter,
            sort: false
        },
        {
            dataField: 'timestamp',
            text: 'Time',
            headerClasses: 'table-col-head',
            headerStyle: { whiteSpace: 'wrap', width: '120px' },
            sort: true
        }
    ];

    const rowEvents = {
        onDoubleClick: (e, row) => {
            openTourDetail(row);
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes='table-md table-responsive-sm text-center align-middle'
            keyField='itKey'
            data={data}
            columns={columns}
            striped
            hover
            condensed
            bordered={false}
            noDataIndication='Record not found'
            rowEvents={rowEvents}
        />
    );
};

HistoryTable.propTypes = {
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    openTourDetail: PropTypes.func,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    isFilterOn: PropTypes.bool,
    filter: PropTypes.object,
    auth: PropTypes.string,
    actionGetHistory: PropTypes.func,
    actionGetFilteredHistory: PropTypes.func,
    actionSetDefaultPic: PropTypes.func,
    actionNextPage: PropTypes.func,
};

export default HistoryTable;



// WEBPACK FOOTER //
// ./src/components/blocks/HistoryTable/HistoryTable.js